import React from 'react';
import { GyeNyame, Sankofa, DwennimmenAdinkra, AkomaNtoaso, Adinkrahene } from './AdinkraSymbols';

const SYMBOLS = [GyeNyame, Sankofa, DwennimmenAdinkra, AkomaNtoaso, Adinkrahene];

/**
 * Floating Adinkra symbols scattered as background decorations.
 * Each symbol is absolutely positioned, low-opacity, with float/spin animations.
 */
export const FloatingAdinkra = ({ count = 6, color = 'rgba(201, 168, 76, 0.07)' }) => {
  // Deterministic positions for consistent layout
  const placements = [
    { top: '5%', left: '3%', size: 90, delay: 0, duration: 12 },
    { top: '15%', right: '5%', size: 70, delay: 2, duration: 15 },
    { top: '40%', left: '1%', size: 60, delay: 4, duration: 18 },
    { top: '55%', right: '2%', size: 80, delay: 1, duration: 14 },
    { top: '75%', left: '4%', size: 55, delay: 3, duration: 16 },
    { top: '85%', right: '6%', size: 65, delay: 5, duration: 13 },
    { top: '30%', right: '8%', size: 50, delay: 2.5, duration: 20 },
    { top: '65%', left: '6%', size: 75, delay: 1.5, duration: 17 },
  ];

  return (
    <div className="floating-adinkra-container" aria-hidden="true">
      {placements.slice(0, count).map((pos, i) => {
        const Symbol = SYMBOLS[i % SYMBOLS.length];
        const style = {
          position: 'absolute',
          top: pos.top,
          left: pos.left,
          right: pos.right,
          animation: `adinkraFloat ${pos.duration}s ease-in-out ${pos.delay}s infinite, adinkraSpin ${pos.duration * 3}s linear ${pos.delay}s infinite`,
          zIndex: 0,
          pointerEvents: 'none',
        };
        return (
          <div key={i} style={style}>
            <Symbol size={pos.size} color={color} />
          </div>
        );
      })}
    </div>
  );
};

/**
 * Full-width Kente cloth strip — a thick, woven-look decorative band.
 */
export const KenteClothStrip = ({ height = 40, className = '' }) => (
  <div className={`kente-cloth-strip ${className}`} style={{ height }} aria-hidden="true">
    <div className="kente-weave-layer kente-warp" />
    <div className="kente-weave-layer kente-weft" />
  </div>
);

/**
 * Section wrapper with layered background, floating Adinkra, and Kente accents.
 */
export const LayeredSection = ({ children, adinkraCount = 4, showKente = true, className = '' }) => (
  <div className={`layered-section ${className}`}>
    <FloatingAdinkra count={adinkraCount} />
    <div className="layered-section-content" style={{ position: 'relative', zIndex: 2 }}>
      {children}
    </div>
    {showKente && <KenteClothStrip />}
  </div>
);
